export const usStates = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

export const COMPENSATION_RANGES = [
  "$0-$10000",
  "$10000-$20000",
  "$20000-$30000",
  "$30000-$40000",
  "$40000-$50000",
  "$50000-$60000",
  "$60000-$70000",
  "$70000-$80000",
  "$80000-$90000",
  "$90000-$100000",
  "$100000-$110000",
  "$110000-$120000",
  "$120000-$130000",
  "$130000-$140000",
  "$140000-$150000",
];

export const JOB_STATUS_OPTIONS = [
  { value: "Draft", label: "Draft" },
  { value: "Open", label: "Open" },
  { value: "On Hold", label: "On Hold" },
  { value: "Filled", label: "Filled" },
  { value: "Canceled", label: "Canceled" },
];

export const EMPLOYMENT_TYPES = ["Contractor", "Full-time", "Intern", "Part-time"];

export const EXPERIENCE_LEVELS = [
  "Entry-Level (1-2 years)",
  "Mid-Level (2-3 years)",
  "Experienced (3-5 years)",
  "Manager/Supervisor (5-6 years)",
  "Senior Manager/Supervisor (6-7 years)",
  "Executive (7-8 years)",
  "Senior Executive (8-10 years)",
];
